/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */
import type { PrescriptionPharmacyAddress } from "./PrescriptionPharmacyAddress";
import type { PrescriptionPharmacyContact } from "./PrescriptionPharmacyContact";

export interface PrescriptionPharmacy {
  name?: string | null;
  address?: PrescriptionPharmacyAddress | null;
  contacts?: PrescriptionPharmacyContact[];
}
